// src/pages/WantadDetailsSkeleton.js
import React from "react";

const skeletonItems = Array(3).fill(0);

const MatchesSkeletonMob = () => (
  <div className="matches-skeleton-mob">
    {skeletonItems.map((_, idx) => (
      <div key={idx} className="matches-skeleton-mob-card">
        <div className="shimmer matches-skeleton-mob-badge" />
        <div className="shimmer matches-skeleton-mob-title" />
        <div className="shimmer matches-skeleton-mob-subtitle" />
        <div className="shimmer matches-skeleton-mob-img" />
        <div className="shimmer matches-skeleton-mob-price" />
        <div className="matches-skeleton-mob-info-row">
          <div className="shimmer matches-skeleton-mob-info" />
          <div className="shimmer matches-skeleton-mob-info" />
          <div className="shimmer matches-skeleton-mob-info" />
        </div>
        <div className="matches-skeleton-mob-tags">
          <div className="shimmer matches-skeleton-mob-tag" />
          <div className="shimmer matches-skeleton-mob-tag" />
          <div className="shimmer matches-skeleton-mob-tag" />
        </div>
        <div className="matches-skeleton-mob-footer">
          <div className="shimmer matches-skeleton-mob-avatar" />
          <div className="matches-skeleton-mob-footer-info">
            <div className="shimmer matches-skeleton-mob-line w-75" />
            <div className="shimmer matches-skeleton-mob-line w-50" />
          </div>
        </div>
      </div>
    ))}
  </div>
);

export default MatchesSkeletonMob;
